import { ID_RE, USERNAME } from 'mk2/helpers/urls';

const MAIL_ID = `:id(${ID_RE})`;

export const mailUrl = '/mail/';
export const mailComposeUrl = '/mail/compose/';
export const mailBoxUrl = `/mail/${USERNAME}/:folder(inbox|outbox|starred)/`;
export const mailDetailUrl = `/mail/${MAIL_ID}/`;
export const mailDetailInFolderUrl = `/mail/:folder(inbox|outbox|starred)/${MAIL_ID}/`;
